module.exports = __webpack_public_path__ + "img/限时商品7.8adc4ed9.png";